#geography,#geography-content{height:-webkit-calc(100% - 5rem);height:calc(100% - 5rem);overflow:hidden}.geography-page{overflow:visible!important}
/*# sourceMappingURL=geography.component-MMIFP6N5.css.map */
